import React, { useState, useEffect } from "react";
import menu from "../../assets/images/menu.svg";
import { NavLink, Link } from "react-router-dom";
import LanguageSelection from "./LanguageSelection";
import { useDispatch, useSelector } from "react-redux";
import { changeShowMenu } from "../../redux/slices/showMenuSlice";
import { fetchMenuGroupGet } from "../../redux/slices/menuGroupGetSlice";
import { fetchSettingsGet } from "../../redux/slices/settingsGetSlice";
import { URL } from "../../api";

const Header = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.lang.lang);
  const showMenu = useSelector((state) => state.showMenu.showMenu);
  const menuGroupGet = useSelector((state) => state.menuGroupGet.data);
  const settings = useSelector((state) => state.settingsGet.data);
  const [isScrolled, setIsScrolled] = useState(false);

  const getData = async () => {
    await dispatch(fetchMenuGroupGet());
    await dispatch(fetchSettingsGet())
  }

  useEffect(() => { getData() }, [dispatch])

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const headerStyle = !isScrolled ? { background: 'linear-gradient(180deg, rgba(89, 87, 87, 0.92) 0%, rgba(53, 51, 51, 0.88) 50%, rgba(0, 0, 0, 0.74) 100%)' } : {};

  return (
    <div className={`header ${isScrolled ? "header-scrolled" : ""}`} style={headerStyle}>
      {!showMenu && (
        <div className="logo">
          <Link to="/">
            <img src={`${URL}${isScrolled ? settings?.darkLogo : settings?.file}`} alt="Logo" loading="lazy" />
          </Link>
        </div>
      )}
      <div className="menu">
        <ul>
          {
            (menuGroupGet?.menus ? [...menuGroupGet.menus] : [])
              .sort((a, b) => a.sort - b.sort)
              .map((item, index) => {
                return (
                  <li key={index}>
                    <NavLink
                      to={lang === "tr" ? `/${item?.slug?.tr}` : `/${item?.slug?.en}`}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      {item?.title[lang]}
                    </NavLink>
                  </li>
                )
              })
          }

          <LanguageSelection />
        </ul>
      </div>

      <div className="mobile-selection d-flex justify-content-end align-items-center">
        <div></div>
      </div>
      {!showMenu && (
        <div className="mobile-selection d-flex justify-content-end align-items-center">
          <div></div>
          <div
            className="mobile-menu-btn ml-3"
            onClick={() => dispatch(changeShowMenu(true))}
          >
            <img src={menu} alt="" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
